import SearchingPanel from './SearchingPanel.vue';

export { SearchingPanel };
export default SearchingPanel;
